module.exports = __webpack_public_path__ + "img/arrow-forward.2a702c15.svg";